import styled from "styled-components";

export const Form = styled.form`
    max-width: 200px;
`
export const FormLabel = styled.label`
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 5px;
`
export const FormTextarea = styled.textarea`
    resize: none;
    height: 50px;
`
